import React from 'react'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import LayoutContainer from 'components/Common/LayoutContainer'
import TrackedCardCarousel from 'components/Common/TrackedCardCarousel/TrackedCardCarousel'
import CruiseDestinationsSectionItem from './CruiseDestinationsSectionItem'
import TrackingContext from 'contexts/trackingContext'
import qs from 'qs'
import Heading from 'LuxKit/Typography/Heading'

const departures = [
  {
    name: 'Cruises from Sydney',
    image: { id: 'v4kwli3fa6d30n2w1rk9' },
    filter: qs.stringify({
      departureIds: 'le_acf06cdd9c744f969958e1f085554c8b',
      departureNames: 'Sydney',
    }),
  },
  {
    name: 'Cruises from Melbourne',
    image: { id: '3wgitcdr0mdfwtfa02ve' },
    filter: qs.stringify({
      departureIds: 'le_bbaa9d6a1445eac881750bea6053f564',
      departureNames: 'Melbourne',
    }),
  },
  {
    name: 'Cruises from Brisbane',
    image: { id: 'e3shvrl7vnuw84mb3fbj' },
    filter: qs.stringify({
      departureIds: 'le_67e103b0761e60683e83c559be18d40c',
      departureNames: 'Brisbane',
    }),
  },
  {
    name: 'Cruises from Rome',
    image: { id: 'wbk1yjnf56awezs1lu' },
    filter: qs.stringify({
      departureIds: 'le_09d37c08f7b129e96277388757530c72,le_675c2bf8873ef7dc8e8b6ba66366a158',
      departureNames: 'Rome',
    }),
  },
]

function CruisePageDeparturesSection() {
  return (
    <TrackingContext.Provider
      value={{
        category: 'cruise_departures',
        label: 'Cruise Page Departures',
        listId: 'cruise-departures-carousel',
        listName: 'Cruise Page Departures',
      }}
    >
      <Group gap={32} direction="vertical">
        <LayoutContainer>
          <Heading variant="heading3">
            Top ports to start your <i>adventure</i>
          </Heading>
        </LayoutContainer>

        <LayoutContainer>
          <TrackedCardCarousel pageSize={6} width={rem(180)}>
            {departures.map((departure, index) => (
              <CruiseDestinationsSectionItem
                key={departure.image.id}
                destination={departure}
                position={index}
                href={`/search/cruises?${departure.filter}`}
                image={departure.image}
                heading={departure.name}
                subHeading=""
                align="top"
                callToAction="View offers"
              />
            ))}
          </TrackedCardCarousel>
        </LayoutContainer>
      </Group>
    </TrackingContext.Provider>
  )
}

export default CruisePageDeparturesSection
